import { gql } from '@apollo/client';

const observationReportNotificationFragment = gql`
  fragment ObservationReportNotificationFields on ObservationReportNotification {
    EventId
    ObservedUser {
      Id
      FullName
    }
  }
`;

export default observationReportNotificationFragment;
